export const CHAT_MARGIN = 16

export const CHAT_EVENT_LAYOUT_UPDATE = 'CHAT_LAYOUT_UPDATE'
